<template>
  <section id="tab-explore" class="section h-offset">

    <div class="inner container">
        <tabs>
            <tab v-for="(tab, idx) in tabs" :key="'discover-' + tab.param" :name="tab.param" :selected="idx == 0">
                <template v-slot:button>
                    <span>{{ tab.label }}</span>
                </template>
                
                <ul class="image-grid" :data-results="tab.children.length">
                    <li v-for="child in tab.children">
                        <a :href="`/explore/${tab.param}/${child.slug}`" class="tinted tinted-20 tinted-hover img-link">
                            <div class="inner">
                                <div class="label fg-white font-md wt-md">{{ child.label }}</div>
                            </div>
                            <div class="background" v-if="child.media">
                                <img :src="child.media" class="cover" :alt="child.label" />
                            </div>
                        </a>
                    </li>
                </ul>
            </tab>
        </tabs>

    </div>
    <!-- /.inner.container -->

  </section>
</template>


<script>
// Tabs
import Tab from '../tabs/Tab'
import Tabs from '../tabs/Tabs'

export default {
    components: {
        Tab,
        Tabs,
    },
    
    data () {
        return {
            loading:    false,
            tabs:       [],
        };
    },
    
    created() {
        this.loadCategories();
    },
    
    methods: {
        loadCategories() {
            this.loading = true;
            
            axios.get('/api/discover')
                 .then((response) => {
                    this.tabs = response.data;
                 })
                 .catch((error) => {})
                 .then(() => {
                    this.loading = false;
                 });
        },
    },
}
</script>